<template>
  <div class="vipComparison">
    <div class="vipComparison-name">
      <span>新老会员成交分析</span>
    </div>

    <div class="selectCont">
      <div class="basics">
        <span>数据指标：</span>
        <el-checkbox v-model="defile" disabled>数值</el-checkbox>
        <el-checkbox v-model="comparison">对比同期</el-checkbox>
      </div>
    </div>

    <div class="dataTable">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" label="会员类型" width="280" fixed></el-table-column>
        <el-table-column prop="date" label="成交会员数" min-width="180"></el-table-column>
        <el-table-column prop="date" label="成交会员占比" min-width="180"></el-table-column>
        <el-table-column prop="date" label="支付订单数" min-width="180"></el-table-column>
        <el-table-column prop="date" label="客单价(元)" min-width="180"></el-table-column>
        <el-table-column prop="date" label="支付金额(元)" min-width="180"></el-table-column>
        <el-table-column prop="date" label="支付金额占比" min-width="180"></el-table-column>
      </el-table>
    </div>

    <div id="ComparisonBox" style="width: 100%;height: 300px;"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      radio1: "1",
      tableData: [],
      defile: true,
      comparison: false
    };
  },
  mounted() {
    this.initMapData();
  },
  methods: {
    initMapData() {
      console.log(1212);
      this.Comparison = echarts.init(document.getElementById("ComparisonBox"));

      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          show: true,
          //设置tip提示
          trigger: "item"
        },
        grid: {
          // 图格配置
          left: "40px",
          right: "30px"
        },
        legend: {
          type: "plain", //----图例类型，默认为'plain'，当图例很多时可使用'scroll'
          top: "1%", //----图例相对容器位置,top\bottom\left\right
          selected: {
            新成交会员数: true,
            老成交会员数: true //----图例选择,图形加载出来会显示选择的图例，默认为true
          },
          textStyle: {
            //----图例内容样式
            color: "#fff" //---所有图例的字体颜色
            //backgroundColor:'black',  //---所有图例的字体背景色
          },
          tooltip: {
            //图例提示框，默认不显示
            show: true,
            color: "red"
          },
          data: [
            //----图例内容
            {
              name: "新成交会员数",
              icon: "circle", //----图例的外框样式
              textStyle: {
                color: "#b0e01e" //----单独设置某一个图例的颜色
                //backgroundColor:'black',//---单独设置某一个图例的字体背景色
              }
            },
            {
              name: "老成交会员数",
              icon: "circle", //----图例的外框样式
              textStyle: {
                color: "#3AA1FF" //----单独设置某一个图例的颜色
                //backgroundColor:'black',//---单独设置某一个图例的字体背景色
              }
            }
          ]
        },
        color: ["#b0e01e", "#3AA1FF"], //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: {
          //设置x轴
          type: "category",
          alignWithLabel: true,
          boundaryGap: true, //坐标轴两边不留白
          data: [
            "2019-1-1",
            "2019-2-1",
            "2019-3-1",
            "2019-4-1",
            "2019-5-1",
            "2019-6-1",
            "2019-7-1"
          ],
          name: "", //X轴 name
          nameTextStyle: {
            //坐标轴名称的文字样式
            color: "#3AA1FF",
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: {
            //坐标轴轴线相关设置。
            lineStyle: {
              color: "#3AA1FF"
            }
          }
        },
        yAxis: {
          name: "",
          nameTextStyle: {
            color: "#3AA1FF",
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          axisLine: {
            lineStyle: {
              color: "#3AA1FF"
            }
          },
          type: "value"
        },
        series: [
          {
            name: "新成交会员数",
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            itemStyle: {
              color: "#b0e01e"
            }
          },
          {
            name: "老成交会员数",
            data: [110, 130, 120, 200, 150, 80, 70],
            type: "bar",
            itemStyle: {
              color: "#3AA1FF"
            }
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.Comparison.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
.vipComparison {
  padding: 16px;
  background: #fff;
  margin-bottom: 14px;

  .vipComparison-name {
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    height: 24px;
    margin-bottom: 20px;
  }

  .selectCont {
    padding: 16px;
    background: #f7f8fa;
    margin-bottom: 14px;

    .basics {
      font-size: 14px;
      margin-bottom: 14px;
    }
  }

  .dataTable {
    margin-bottom: 14px;
  }
}
</style>

<style lang="scss">
.vipComparison {
  .el-table {
    th {
      background-color: #f7f8fa;
    }
  }
}
</style>
